export default function({ route, $cookies }) {
  const aff = route.query.aff
  if (aff) {
    // Save to cookies for 30 days
    // last click: always overwrite with the newest code
    $cookies.set('aff_code', aff, {
      path: '/',
      maxAge: 60 * 60 * 24 * 30 // 30 days in seconds
    })
  }
}
